import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent {
  isLoggedIn = false;

  constructor(private authservice: AuthService) {}

  ngOnInit(): void {
    this.isLoggedIn = !!this.authservice.checkTokenExpiry();
  }
}
